export const ORDER_BOOK_CELLS_COUNT = 10;

export enum CellOpacity {
  DefaultEven = 0.8,
  DefaultOdd = 0.6,
  Even = 0.5,
  Odd = 0.2,
}
